import Vue from 'vue'
import VueRouter from 'vue-router';
import App from './App.vue'
import router from './router'
import './plugins/element.js'
import './assets/css/common.css'
import axios from 'axios'
import qs from 'qs'
import '@/assets/font/iconfont.css'
import '@/assets/js/rem.js'

import scroll from 'vue-seamless-scroll'
Vue.use(scroll)


Vue.use(qs);
Vue.prototype.$axios = axios;

Vue.prototype.Api = Glob.baseUrl;
// 导航
Vue.prototype.NavList = [
    {
        first: "中心概况",
        second: [
            { title: "中心介绍" },
            { title: "中心荣誉" },
            { title: "组织架构" },
        ],
    },
    {
        first: "新闻资讯",
        second: [
            { title: "公示公告" },
            { title: "医院动态" },
            { title: "疗休养工作动态" },
            { title: "健康科普" },
            { title: "护理园地" },
        ],
    },
    {
        first: "党建园地",
        second: [
            { title: "党建信息" },
            { title: "主题教育" },
            { title: "支部建设" },
            { title: "党员风采" },
            { title: "廉政建设" },
        ],
    },
    {
        first: "门诊介绍",
        second: [
            { title: "门诊设置" },//0
            { title: "口腔门诊" },//1
            { title: "眼科门诊" },//2
            { title: "尘肺门诊" },//2-3
            { title: "康复门诊" },//3-4
            { title: "盆底肌（产后）康复门诊" },//4-5
            { title: "内科门诊" },//7-6
            { title: "工伤门诊" },//8-7
        ],
    },
    {
        first: "体检服务",
        second: [
            {
                title: "体检中心介绍", children: [
                    { title: "健康体检服务" },
                    { title: "职业健康体检服务" },
                    { title: "劳动模范健康体检服务" },
                    { title: "万人免费健康体检服务" },
                    { title: "职业病（工伤）人员健康体检服务" },
                    { title: "驾驶人体检服务" },
                    { title: "健康体检" },
                ]
            },//0
            { title: "体检工作动态" },//1
        ],
    },
    {
        first: "医疗康复",
        second: [
            { title: "康复科介绍" },
            { title: "康复项目介绍" },
            { title: "康复医疗范围" },
            { title: "盆底肌（产后）康复门诊" },
            { title: "医疗康复动态" },
        ],
    },
    {
        first: "疗休养工作",
        second: [
            { title: "北戴河疗养院" },
            { title: "疗休养服务" },
            { title: "外埠合作疗养院" },
        ],
    },
    {
        first: "联系我们",
        second: [
            { title: "来院路线" },
            { title: "院内地图" },
            { title: "联系电话" },
            { title: "公众号" },
        ],
    },
]

const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error)
}

Vue.config.productionTip = false
new Vue({
    router,
    render: h => h(App)
}).$mount('#app')
